import { useMutation, useQueryClient } from '@tanstack/vue-query';
import httpClient from '../httpClient';
import type { MantaPatient } from '@/types';
import type { SpeciesKey } from '@/lib/species';

export interface UpdatePatientPayload {
  name?: string;
  species?: SpeciesKey | null;
}

/** Updates a Manta-created patient (via the scribe-backend proxy). */
export const usePatientUpdate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      id,
      data,
    }: {
      id: string;
      data: UpdatePatientPayload;
    }): Promise<MantaPatient> => {
      const response = await httpClient.patch<MantaPatient>(
        `/v1/patients/${id}`,
        data,
      );
      return response.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['scribeClientPatients'],
      });
      void queryClient.invalidateQueries({ queryKey: ['scribeClientSearch'] });
    },
  });
};
